import { Button as BootstrapButton, type ButtonProps } from "react-bootstrap";
import Loading from "./Loading";

interface Props extends Omit<ButtonProps, "as"> {
  // Omit 'as' for now. Apparently conflicts with it own types.
  text?: string;
  loading?: boolean;
}

export default function Button({
  loading = false,
  text,
  children,
  ...rest
}: Props) {
  return (
    <BootstrapButton disabled={loading} {...rest}>
      <Loading isLoading={loading} text={text} color="text-white">
        {children}
      </Loading>
    </BootstrapButton>
  );
}
